/** See `src/i18n/locales/en/reports.ts`. */
export const reports = {
  page: {
    title: 'Rapports',
    lead: 'Rapports pour {{company}}, construits à partir de données existantes — aucune donnée de rapport distincte n’est stockée.',
    noScope: 'Sélectionnez une entreprise pour voir ses rapports.',
    forbidden: 'Vous n’êtes pas autorisé à voir les rapports de cette entreprise.',
  },
  library: {
    title: 'Bibliothèque de rapports',
  },
  cards: {
    vitaliteitstrends: {
      title: 'Tendances de vitalité mensuelles',
      description: 'Nombre total de pas par mois pour l’ensemble de l’entreprise.',
    },
    deelnamerapport: {
      title: 'Rapport de participation',
      description: 'Combien de membres sont actifs, et depuis quand.',
    },
    'challenge-resultaten': {
      title: 'Résultats des challenges',
      description: 'Challenges par statut et progression moyenne des participants.',
    },
    communicatiebereik: {
      title: 'Portée de la communication',
      description: 'Notifications envoyées, livrées et ouvertes.',
    },
    documentgebruik: {
      title: 'Utilisation des documents',
      description: 'Documents publiés/archivés et leur nombre total de vues.',
    },
  },
  actions: {
    exportCsv: 'Exporter en CSV',
    exportPdf: 'Exporter en PDF',
  },
  export: {
    pdfFallbackNote:
      'L’export PDF n’est pas encore disponible — un fichier CSV a été téléchargé à la place.',
    error: 'Ce rapport n’a pas pu être exporté.',
  },
} as const;
